import { Badge, Title } from "@components";
import styles from "@styles/pages/reports/reports.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { If } from "shared/components/control-statements";
import { UserStorage } from "shared/tools/UserStorage";

export default function LoyaltyReports() {
  let pages = [
    {
      name: "Indicadores de cashback",
      icon: <i className="fal fa-dial" />,
      path: "indicadores",
      enabled: true,
      allowed: true,
    },
    {
      name: "Indicadores de pontos",
      icon: <i className="fal fa-dial" />,
      path: "indicadores-de-pontos",
      enabled: false,
      allowed: true,
    },
    {
      name: "Engajamento",
      icon: <i className="fal fa-thumbs-up" />,
      path: "engajamento",
      enabled: true,
      allowed: false,
    },
  ];

  const program = localStorage.getItem("cashbackProgram")
    ? JSON.parse(localStorage.getItem("cashbackProgram"))
    : null;

  if (program?.type === "POINT") {
    pages.find((p) => p.name === "Indicadores de pontos").enabled = true;
    pages.find((p) => p.name === "Indicadores de cashback").enabled = false;
  }

  const navigate = useNavigate();

  return (
    <>
      <Title title="Relatórios de Fidelização" />

      <div className={styles.reports}>
        {pages
          .filter((p) => !!p.enabled)
          .map((page, index) => {
            return (
              <>
                <If cond={page.allowed}>
                  <Link to={page.path} key={page.name}>
                    <div className={styles.report} style={{ opacity: 1 }}>
                      <div className="d-flex align-center">
                        <div className={styles.icon}>{page.icon}</div>
                        <p>{page.name}</p>
                      </div>
                    </div>
                  </Link>
                </If>

                <If cond={!page.allowed}>
                  <div
                    className={styles.report}
                    style={{ opacity: 1 }}
                    onClick={() => {
                      if (UserStorage.isGodMode) navigate(page.path);
                    }}
                  >
                    <div className="d-flex align-center">
                      <div className={styles.icon}>{page.icon}</div>
                      <p>{page.name}</p>
                    </div>

                    <Badge type="exclamation" name="Em breve" />
                  </div>
                </If>
              </>
            );
          })}
      </div>
    </>
  );
}
